import { render, staticRenderFns } from "./SponsorCard.vue?vue&type=template&id=ae307a08"
import script from "./SponsorCard.vue?vue&type=script&lang=js"
export * from "./SponsorCard.vue?vue&type=script&lang=js"
import style0 from "./SponsorCard.vue?vue&type=style&index=0&id=ae307a08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports